import { render, staticRenderFns } from "./merk-dagang-beliruma.vue?vue&type=template&id=bbba7db2"
import script from "./merk-dagang-beliruma.vue?vue&type=script&lang=js"
export * from "./merk-dagang-beliruma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports